<template>
    <div class="space-y-6">
        <p>
            Lassen Sie uns Ihren Merkzettel zukommen, um ein unverbindliches Angebot zu erhalten. Füllen Sie dazu bitte
            Ihre Kontaktdaten aus und teilen Sie uns mit, ob Lieferung und Montage grundsätzlich gewünscht sind:
        </p>

        <form
            class="contact-form space-y-4 py-4 text-xs lg:space-y-8 lg:py-0 lg:text-base"
            @submit.prevent="sendMessage"
        >
            <div class="space-y-4">
                <div class="grid grid-cols-2">
                    <UCheckbox
                        v-model="assembly"
                        label="Ich wünsche Informationen zur Montage"
                        style="padding-inline: 0 !important; padding-block: 0 !important;"
                    />
                    <UCheckbox
                        v-model="shipping"
                        label="Ich wünsche Informationen zur Lieferung"
                        style="padding-inline: 0 !important; padding-block: 0 !important;"
                    />
                </div>

                <UFormField
                    label="Ihre Nachricht an uns"
                    required
                >
                    <UTextarea
                        v-model="message"
                        :rows="6"
                        placeholder="Ihre Nachricht"
                        class="w-full"
                    />
                </UFormField>

                <div class="grid-cols-2 gap-6 space-y-4 xl:grid xl:space-y-0">
                    <UFormField
                        label="Vorname"
                        required
                    >
                        <UInput
                            v-model="store.userData.firstName"
                            placeholder="Vorname"
                            type="text"
                            class="w-full"
                        />
                    </UFormField>
                    <UFormField
                        label="Nachname"
                        required
                    >
                        <UInput
                            v-model="store.userData.lastName"
                            placeholder="Nachname"
                            type="text"
                            class="w-full"
                        />
                    </UFormField>
                    <UFormField
                        label="Straße und Hausnr."
                        required
                    >
                        <UInput
                            v-model="store.userData.street"
                            placeholder="Straße und Hausnr."
                            type="text"
                            class="w-full"
                        />
                    </UFormField>
                    <UFormField
                        label="Ihre Postleitzahl"
                    >
                        <UInput
                            v-model="store.userData.zip"
                            placeholder="Postleitzahl"
                            type="number"
                            class="w-full"
                        />
                    </UFormField>
                    <UFormField
                        label="Ort"
                        required
                    >
                        <UInput
                            v-model="store.userData.city"
                            placeholder="Ort"
                            type="text"
                            class="w-full"
                        />
                    </UFormField>
                    <UFormField
                        label="Land"
                        required
                    >
                        <UInput
                            v-model="store.userData.country"
                            placeholder="Land"
                            type="text"
                            class="w-full"
                        />
                    </UFormField>
                    <UFormField
                        label="Ihre E-Mail-Adresse"
                        :required="mode === 'contact'"
                    >
                        <UInput
                            v-model="store.userData.email"
                            placeholder="E-Mail-Adresse"
                            type="email"
                            class="w-full"
                        />
                    </UFormField>
                    <UFormField
                        label="Ihre Telefonnummer"
                        :required="mode === 'callback'"
                    >
                        <UInput
                            v-model="store.userData.phone"
                            placeholder="Telefonnummer"
                            type="tel"
                            class="w-full"
                        />
                    </UFormField>
                </div>
                <UCheckbox
                    v-model="privacy"
                    size="xl"
                    variant="list"
                    required
                    label="Ich habe die Datenschutzhinweise zur Kenntnis genommen!"
                    style="padding-inline: 0 !important; padding-block: 0 !important;"
                />
            </div>

            <div class="block text-xs">
                Bei den mit einem Sternchen (*) markierten Feldern handelt es sich um Pflichtfelder!
            </div>

            <button
                class="w-full bg-primary text-white flex! gap-2 justify-center py-2"
                type="submit"
            >
                Unverbindliches Angebot anfragen
            </button>
        </form>
    </div>
</template>

<script setup lang="ts">
import {computed, ref, watchEffect} from 'vue';
import {z} from 'zod';
import {useForm, useField} from 'vee-validate';
import {toTypedSchema} from '@vee-validate/zod';
import {useWishlistStore} from '~~/stores/wishlist';

const {public: pub} = useRuntimeConfig();
const store = useWishlistStore();
const emit = defineEmits<{(e: 'close'): void
    (e: 'sent', payload: { success: boolean }): void
}>();

const mode = ref<'contact' | 'booking' | 'callback'>('contact');
const assembly = ref(false);
const shipping = ref(false);

// Fields = Single Source of Truth
const {value: message} = useField<string>('message');
const {value: privacy} = useField<boolean>('privacy');

async function sendMessage() {
    if (privacy.value) {
        const response = await $fetch<{ sent: boolean }>(`${pub.apiUrl}${store.wishlistId}/offer`, {
            method: 'POST',
            body: {
                assembly: assembly.value,
                shipping: shipping.value,
                message: message.value,
                userData: store.userData,
            },
        });

        if (response.sent) {
            const toast = useToast();

            toast.add({
                title: 'Erfolgreich versendet',
                description: 'Ihre Nachricht wurde erfolgreich versendet.',
                color: 'success',
            });

            emit('close');
        }
    }
}
</script>
